module.exports = __webpack_public_path__ + "static/media/icon-burger.033efce9.svg";